var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.877,
    height: 23.432,
    viewBox: "0 0 29.877 23.432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "people_love_us_icon6",
    transform: "translate(0.858 1.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10",
    "data-name": "\\uD328\\uC2A4 10",
    d: "M849,1306.644c.55-.92,1.1-2.741,2.887-2.741s2.676,2.917,4.241,2.741c2.3-.259.952-13.385,4.462-14.143s.994,21.355,4.194,21.405,2.7-10.779,4.864-10.843,1.766,4.815,4.034,4.793,2.485-2.716,4.318-2.751",
    transform: "translate(-849 -1292.481)",
    fill: "none",
    stroke: "#ff457e",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRope);
export default __webpack_public_path__ + "static/media/rope.167778df8aceda78c398336862100248.svg";
export { ForwardRef as ReactComponent };